import { IOfferSpendByOfferScopeListTableLang } from '../../../types/lang'

export const offerSpendByOfferScopeListTableLang: IOfferSpendByOfferScopeListTableLang = {
	offer_spend_by_offer_scope_list_table: {
		column_scope_id: 'Scope ID_ru',
		column_scope: 'Scope_ru',
		column_scope_in_group: 'Scope in Group_ru',
		column_amount: 'Amount_ru',
		column_date: 'Date_ru',
	}
}